export default __webpack_public_path__ + "static/media/barclays4.589dc84f.jpg";